import moment from 'moment';
import { updateProposal } from 'services/proposal.service';
import { extendSoftBlockedResource } from 'services/softBlockedResource.service';
import { updateSuggestion } from 'services/suggestion.service';
import useGlobalToastStore from 'store/globalToastStore';

const useShortlistedHooks = () => {
    const { setToastData } = useGlobalToastStore();

    const onEditProposal = async (data, row) => {
        const {
            startDate, endDate, hoursPerWeek, id, resourceId
        } = data

        const { demandId } = row

        const res = await updateProposal(
            id,
            resourceId,
            demandId,
            // startDate,
            // endDate,
            moment(startDate).utc().format('yyyy-MM-DDTHH:mm:ss.SSS[Z]'),
            moment(endDate).utc().format('yyyy-MM-DDTHH:mm:ss.SSS[Z]'),
            hoursPerWeek
        );
        if (res?.status) {
            setToastData({
                show: true,
                type: 'success',
                message: `The proposal has been updated successfully!`
            });
            setTimeout(() => {
                setToastData({});
            }, 3000);
            return { success: true, data };
        } else if (res?.error?.response?.status === 400) {
            setToastData({ show: true, message: res?.error?.response?.data?.message, type: 'error' });
        }
        else {
            setToastData({ show: true, message: 'Something went wrong', type: 'error' });
        }
        setTimeout(() => {
            setToastData({});
        }, 3000);
        return { success: false, validationErrors: {} };
    };

    const onEditSoftBlock = async (data, softblock) => {
        const {
            startDate, endDate, hoursPerWeek, reasonForExtension, scheduleStartDate, scheduleEndDate
        } = data;
        const formattedStartDate = moment(startDate).startOf('day').utc().format();
        const formattedEndDate = moment(endDate).startOf('day').utc().format();
        const formattedScheduleStartDate = moment(scheduleStartDate).startOf('day').utc().format();
        const formattedScheduleEndDate = moment(scheduleEndDate).startOf('day').utc().format();

        const res = await extendSoftBlockedResource(softblock.id, {
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            extendReason: reasonForExtension,
            scheduleEndDate: formattedScheduleEndDate,
            scheduleStartDate: formattedScheduleStartDate,
            weeklyHours: hoursPerWeek
        });
        if (res?.status) {
            setToastData({
                show: true,
                type: 'success',
                message: `Soft-blocked employee details updated successfully!`
            });
            setTimeout(() => {
                setToastData({});
            }, 3000);
            return { success: true, data };
        } else if (res?.error?.response?.status === 400) {
            setToastData({ show: true, message: res?.error?.response?.data?.message, type: 'error' });
        }
        else {
            setToastData({ show: true, message: 'Something went wrong', type: 'error' });
        }
        setTimeout(() => {
            setToastData({});
        }, 3000);
        return { success: false, validationErrors: {} };
    };

    const onEditSuggestion = async (data, suggestion) => {
        const res = await updateSuggestion(suggestion.id, {
            weeklyHours: data?.hoursPerWeek,
            endDate: data?.endDate,
            startDate: data?.startDate
        });

        if (res?.status) {
            setToastData({
                show: true,
                type: 'success',
                message: `The suggestion has been updated successfully!`
            });
            setTimeout(() => {
                setToastData({});
            }, 3000);
            return { success: true, data };
        } else if (res?.error?.response?.status === 400) {
            setToastData({ show: true, message: res?.error?.response?.data?.message, type: 'error' });
        }
        else {
            setToastData({ show: true, message: 'Something went wrong', type: 'error' });
        }
        setTimeout(() => {
            setToastData({});
        }, 3000);
        return { success: false, validationErrors: {} };
    };

    return {
        onEditProposal, onEditSoftBlock, onEditSuggestion
    };
};

export default useShortlistedHooks;